export default async (userRepository, email) => {
    const reference = await userRepository.getByEmail(email);
    return {...reference.data(), id: reference.id};
}
